import { z } from 'zod';
import { InteractionProvider } from '../index.js';
export const StraalforsFailedEventSchema = z.object({
    provider: z.literal(InteractionProvider.Straalfors),
    bronzeData: z.null(),
});
//# sourceMappingURL=straalfors.js.map